import { IconType } from './Icons.types';
import { ReactComponent as StudyDirectorIcon } from '../../assets/icons/study_director.svg';
import { ReactComponent as LecturerIcon } from '../../assets/icons/lecturer.svg';
import { ReactComponent as StudentIcon } from '../../assets/icons/student.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg';
import { ReactComponent as DashboardIcon } from '../../assets/icons/dashboard.svg';
import { ReactComponent as StudentsIcon } from '../../assets/icons/students.svg';
import { ReactComponent as AssignmentIcon } from '../../assets/icons/assignment.svg';
import { ReactComponent as WebdocIcon } from '../../assets/icons/webdoc.svg';
import { ReactComponent as HelpIcon } from '../../assets/icons/help.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit_square.svg';
import { ReactComponent as CourseIcon } from '../../assets/icons/course.svg';
import { ReactComponent as CopyIcon } from '../../assets/icons/copy.svg';
import { ReactComponent as SubmittedIcon } from '../../assets/icons/submitted.svg';
import { ReactComponent as ViewIcon } from '../../assets/icons/view_eye.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download.svg';
import { ReactComponent as UploadIcon } from '../../assets/icons/upload.svg';
import { ReactComponent as ThreeDModel } from '../../assets/icons/threeD_model.svg';
import { ReactComponent as AddIcon } from '../../assets/icons/add.svg';
import { ReactComponent as SupportIcon } from '../../assets/icons/support.svg';
import { ReactComponent as ReviewIcon } from '../../assets/icons/search-file-icon.svg';
import { ReactElement, ReactNode } from 'react';
export const iconMapper = new Map<
  IconType,
  | ((props?: any) => JSX.Element)
  | { type: string }
  | string
  | ReactElement
  | ReactNode
>([
  ['help', 'help'],
  ['add', AddIcon],
  ['cancel', CloseIcon],
  ['clear', CloseIcon],
  ['close', CloseIcon],
  ['download', DownloadIcon],
  ['upload', UploadIcon],
  // ['confirm', 'done'],
  // ['print', 'print'],
  // ['refresh', 'refresh'],
  ['edit', EditIcon],
  // ['done', 'done'],
  // ['destroy', 'delete'],
  // ['play', 'play_arrow'],
  // ['touch', 'touch_app'],
  // ['redo', 'redo'],
  ['delete', DeleteIcon],
  // ['remove', 'remove'],
  // ['reset', 'close'],
  // ['restart', 'restart_alt'],
  // ['select', 'touch_app'],
  // ['send', 'send'],
  // ['pause', 'pause'],
  // ['transfer', 'swap_horiz'],
  // ['warning', 'erroroutline'],
  // ['local_shipping', 'local_shipping_outline'],
  // ['event_note', 'event_note'],
  ['view', ViewIcon],
  ['copy', CopyIcon],
  ['submitted', SubmittedIcon],
  // ['view_more', 'expand_more'],
  // ['view_less', 'expand_less'],
  ['logout', LogoutIcon],
  ['help', HelpIcon],
  ['support', SupportIcon],
  ['menu', 'menu'],
  //Business
  ['course', CourseIcon],
  ['course_logo', 'course_logo'],
  ['lecturer', LecturerIcon],
  ['lecturers', LecturerIcon],
  ['admin', StudyDirectorIcon],
  ['study_director', StudyDirectorIcon],
  ['student', StudentIcon],
  ['dashboard', DashboardIcon],
  ['assignments', AssignmentIcon],
  ['assignment', AssignmentIcon],
  ['resources', WebdocIcon],
  ['students', StudentsIcon],
  ['threeD_model', ThreeDModel],
  ['review', ReviewIcon],
  ['group', 'group'],
] as any);
